// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HYmT7","type":"styles_type__16tLY","choices":"styles_choices__nVZg6"};